import { MaskedLine, Reveal } from "../components/motion";
import BookMockup from "../components/BookMockup";
import CtaButton from "../components/CtaButton";
import { config } from "../config/siteConfig";

const Hero = () => (
  <section
    id="hero"
    data-testid="hero-section"
    className="relative min-h-[100svh] bg-[#08162B] text-white overflow-hidden"
  >
    <div className="absolute inset-0 hero-grid pointer-events-none" />
    <div className="hidden lg:block absolute -top-40 right-[-10%] w-[60vw] h-[60vw] rounded-full bg-[#12294D] blur-[140px] opacity-70 pointer-events-none" />

    <div className="relative max-w-[1700px] mx-auto px-5 sm:px-8 lg:px-[6vw] grid lg:grid-cols-12 gap-10 lg:gap-4 items-center pt-32 pb-24 lg:pt-24 lg:pb-16 lg:min-h-[100svh]">
      <div className="lg:col-span-6 xl:col-span-6">
        <Reveal delay={0.1}>
          <div className="flex items-center gap-3 font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-[#D4AF37]">
            <span className="h-px w-16 bg-[#D4AF37]" />
            THE ECOMMERCE BLUEPRINT
          </div>
        </Reveal>

        <h1 className="mt-8 lg:mt-6 leading-[0.88] space-y-2 sm:space-y-3">
          <MaskedLine
            delay={0.25}
            className="font-cover uppercase tracking-[0.01em] text-[clamp(2.7rem,min(5.6vw,8vh),6.4rem)] text-white"
          >
            <span className="inline-block origin-left scale-x-[1.15] sm:scale-x-[1.35] lg:scale-x-[1.5]">THE UNIVERSAL</span>
          </MaskedLine>
          <MaskedLine
            delay={0.4}
            className="font-cover uppercase tracking-[0.01em] text-[clamp(3.7rem,min(7.6vw,10.8vh),8.6rem)]"
          >
            <span className="inline-block origin-left scale-x-[1.15] sm:scale-x-[1.35] lg:scale-x-[1.5] text-[#D4AF37]">PRINCIPLES</span>
          </MaskedLine>
          <MaskedLine
            delay={0.55}
            className="font-cover tracking-[0.03em] text-[clamp(1.8rem,min(3.7vw,5.2vh),4.2rem)] text-white"
          >
            <span className="inline-block origin-left scale-x-[1.08] sm:scale-x-[1.2] lg:scale-x-[1.3]">BEHIND EVERY SUCCESSFUL</span>
          </MaskedLine>
          <MaskedLine
            delay={0.65}
            className="font-cover tracking-[0.03em] text-[clamp(1.8rem,min(3.7vw,5.2vh),4.2rem)] text-white"
          >
            <span className="inline-block origin-left scale-x-[1.08] sm:scale-x-[1.2] lg:scale-x-[1.3]">ECOMMERCE BRAND.</span>
          </MaskedLine>
        </h1>

        <Reveal delay={0.7} className="mt-8 lg:mt-6 max-w-3xl">
          <p data-testid="hero-subheadline" className="text-base sm:text-lg leading-relaxed text-white/80">
            The timeless principles of products, people, offers, marketing, and growth that the
            world's most successful brands understand—and most entrepreneurs learn too late.
          </p>
        </Reveal>

        <Reveal delay={0.75} className="mt-10 lg:mt-7">
          <CtaButton variant="gold" testid="hero-cta-button" />
          <p data-testid="hero-cta-note" className="mt-5 lg:mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
            {config.book.price ? `${config.book.price} • ` : ""}
            {config.book.note}
          </p>
        </Reveal>

        <Reveal delay={0.9} className="mt-12 lg:mt-8 border-t border-white/10 pt-6 lg:pt-5 max-w-xl">
          <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] text-white/70">
            {config.author.name}
          </p>
          <p className="mt-1 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-white/35">
            {config.author.role}
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-6 relative flex items-center justify-center lg:justify-end lg:pr-[6vw] py-10 lg:py-0">
        <div className="absolute w-[520px] h-[520px] lg:w-[700px] lg:h-[700px] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.16),transparent_65%)] blur-2xl pointer-events-none" />
        <BookMockup className="book-scene--hero" />
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden lg:flex flex-col items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
      <span>Scroll</span>
      <span className="h-10 w-px bg-gradient-to-b from-white/40 to-transparent" />
    </div>
  </section>
);

export default Hero;
